import firebase from "../../../../../common/firebase";

export const uploadVideoAndGetURL = async (videoFile, userId) => {
  const timestamp = Date.now();
  const videoPath = `llm_chat_data/video_analyze/${userId}/video_${timestamp}.mp4`;
  const storageRef = firebase.storage().ref(videoPath);
  await storageRef.put(videoFile);
  return `gs://${firebase.storage().ref().bucket}/${videoPath}`;
};

export const uploadFileAndGetGsUrl = async (file, userId, sessionId) => {
  const safeFileName = file.name.replace(/\s+/g, "_");
  const objectPath = `llm_chat_data/file_attachments/${userId}/${sessionId}/${safeFileName}`;
  const storageRef = firebase.storage().ref(objectPath);
  await storageRef.put(file);
  return `gs://${firebase.storage().ref().bucket}/${objectPath}`;
};